<template>
    <div class="page">
    <ion-grid>
      <ion-row class="search-view">
        <ion-col>
          <ion-row align-items-stretch>
             <ion-col size="12" size-md="2">
              <ion-label>Corporate Name</ion-label>
              <div class="border-line-34 margin-top-10">
                <ion-input
                  class="form-input"
                  type="text"
                  id="corporateName"
                  @input="corporateName = $event.target.value"
                  maxlength="100"
                ></ion-input>
              </div>
            </ion-col>
            <ion-col size="12" size-md="2">
              <ion-label>Branch Name</ion-label>
              <div class="border-line-34 margin-top-10">
                <ion-input
                  class="form-input"
                  type="text"
                  id="branch"
                  @input="branch = $event.target.value"
                  maxlength="100"
                ></ion-input>
              </div>
            </ion-col>
            <ion-col size="12" size-md="2">
              <ion-label>Branch ID</ion-label>
              <div class="border-line-34 margin-top-10">
                <ion-input
                  class="form-input"
                  type="text"
                  id="branchId"
                  @input="branchId = $event.target.value"
                  maxlength="50"
                ></ion-input>
              </div>
            </ion-col>
            <ion-col size="12" size-md="2">
              <br />
              <ion-button class="btn-search margin-top-10" @click="searchCPOBranches">Search</ion-button>
              <ion-button class="btn-clear margin-top-10" @click="clearFields">
                <ion-icon :icon="refresh"></ion-icon>
              </ion-button>
              <!-- <ion-button class="btn-search margin-top-10">Search</ion-button> -->
              <!-- <ion-button class="btn-clear margin-top-10">
                <ion-icon name="refresh"></ion-icon>
              </ion-button> -->
            </ion-col>
          </ion-row>
        </ion-col>
      </ion-row>
      <ion-row class="row-divider"></ion-row>
      <ion-row class="list-view">
        <ion-col>
          <ion-row class="list-head">
             <ion-col size="12" size-md="">
              <ion-label>Branch ID</ion-label>
            </ion-col>
            <ion-col size="12" size-md="">
              <ion-label>Corpoarate ID</ion-label>
            </ion-col>
            <ion-col size="12" size-md="">
              <ion-label>Corpoarate Name</ion-label>
            </ion-col>
            <ion-col size="12" size-md="">
              <ion-label>Branch Name</ion-label>
            </ion-col>
            <ion-col size="12" size-md="">
              <ion-label>Branch Status</ion-label>
            </ion-col>
            <ion-col size="12" size-md="">
              <ion-label>Association Status</ion-label>
            </ion-col>
            <ion-col size="12" size-md="">
              <ion-label>Effective From</ion-label>
            </ion-col>
            <ion-col size="12" size-md="">
              <ion-label>Last Effective Date</ion-label>
            </ion-col>
          </ion-row>
          <hr />

          <ion-row class="list-item" v-for="(branch) in this.branches" :key="branch">
            <!-- <ion-row class="list-item"> -->
            <ion-col size="12" size-md="">
              <ion-label class="ext-link" @click="viewBranchDetails(branch)">{{branch.branchId}}</ion-label>
            </ion-col>
            <ion-col size="12" size-md="">
              <!-- <ion-label>{{corporate.corporateId}}</ion-label> -->
              <ion-label>{{branch.corporateId}}</ion-label>
            </ion-col>
            <ion-col size="12" size-md="">
              <!-- <ion-label>{{corporate.corporateName}}</ion-label> -->
              <ion-label>{{branch.corporateName}}</ion-label>
            </ion-col>
            <ion-col size="12" size-md="">
              <!-- <ion-label>{{corporate.branch}}</ion-label> -->
              <ion-label>{{branch.branch}}</ion-label>
            </ion-col>
            <ion-col size="12" size-md="">
              <!-- <ion-label>{{corporate.gstNumber}}</ion-label> -->
              <!-- <ion-label v-bind:class="[{'active': branch.branchStatus.code == 'A'}, {'in-active': branch.branchStatus.code == 'RET'}]">{{branch.branchStatus.description | uppercase}}</ion-label> -->
              <ion-label v-bind:class="[{'active': branch.branchStatus.code == 'A'}, {'in-active': branch.branchStatus.code == 'RET'}]">{{ convertUppercase(branch.branchStatus.description) }}</ion-label>
            </ion-col>
            <ion-col size="12" size-md="">
              <!-- <ion-label v-bind:class="[{'active': branch.associationStatus.code == 'A'}, {'in-active': branch.associationStatus.code == 'I'}]">{{ branch.associationStatus.description | uppercase}}</ion-label> -->
              <ion-label v-bind:class="[{'active': branch.associationStatus.code == 'A'}, {'in-active': branch.associationStatus.code == 'I'}]">{{ convertUppercase(branch.associationStatus.description) }}</ion-label>
            </ion-col>
            <ion-col size="12" size-md="">
              <!-- <ion-label>{{ branch.effectiveDate | dateFormat('DD/MMM/YYYY')}}</ion-label> -->
              <ion-label>{{ changeDateFormatWithoutTime(branch.effectiveDate) }}</ion-label>
            </ion-col>
            <ion-col size="12" size-md="">
              <!-- <ion-label>{{ branch.lastEffectiveDate | dateFormat('DD/MMM/YYYY')}}</ion-label> -->
              <ion-label>{{ changeDateFormatWithoutTime(branch.lastEffectiveDate) }}</ion-label>
            </ion-col>
          </ion-row>
        </ion-col>
      </ion-row>
      <ion-row class="row-divider"></ion-row>
      <ion-row v-if="norecordsfound">
        <ion-col size="12" class="ion-text-center">
          <ion-label class="pagination-info ">No records found for the selected filters</ion-label>
        </ion-col>
      </ion-row>
      <ion-row v-else>
        <ion-col size="12" size-md="5">
          <ion-label
            class="pagination-info"
          >Showing {{((pageRecords * pageNo) <= totalRecords) ? (pageRecords * pageNo) : totalRecords}} of {{totalRecords}} results</ion-label>
        </ion-col>
        <ion-col size="12" size-md="7" class="ion-text-right">
          <div class="pagination">
            <a class="prev" v-if="this.pageNo > 1" @click="loadPage(pageNo - 1)">Prev</a>
            <a class="prev disabled" v-else>Prev</a>
            <a
              
              v-for="page in this.pagesList"
              :key="page"
              v-bind:class="{'active': pageNo == page}"
              @click="loadPage(page)"
            >{{page}}</a>
            <a
             
              class="next"
              v-if="this.pageNo < this.totalPages"
              @click="loadPage(pageNo + 1)"
            >Next</a>
            <a  class="next disabled" v-else>Next</a>
          </div>
        </ion-col>
      </ion-row>
    </ion-grid>
    <div class="spinner">
      <ion-spinner v-if="loaderTab"></ion-spinner>
    </div>
  </div>
</template>

<script>
import { defineComponent } from "vue";
import { PaginationUtils } from "../../util/pagination-utils";
import { CorporateService } from "../../service/corporate/corporate.service";
import { IonButton, IonCol, IonGrid, IonIcon, IonInput, IonLabel, IonRow, IonSpinner } from "@ionic/vue";
import { refresh } from 'ionicons/icons';
import moment from "moment";

export default defineComponent ({
  name: 'branchesAndStations',
  components: {
    IonGrid, IonRow, IonCol, IonLabel, IonInput, IonButton, IonIcon, IonSpinner
  },
  data() {
    return {
      refresh,
      loaderTab: true,
      branches: [],
      statuses: [],
      corporateId: "",
      corporateName: "",
      branch: "",
      gstNumber: "",
      status: "",
      norecordsfound: true,
      totalRecords: 0,
      pageRecords: 15,
      pageNo: 1,
      pagesList: [],
      totalPages: 0,
      
      branchId: ""
    }
  },
  async mounted() {
    // this.statuses = await new CorporateService().getBranchStatus();
    var page = localStorage.getItem('CPOBranchPage');
    if(page) {
    this.pageNo = Number(page);
    }
    var search = localStorage.getItem('CPOBranchSearch');
    if(search) {
        await this.searchCPOBranches();
    }
    this.loaderTab = false;
  },
  methods: {
    changeDateFormatWithoutTime(dateValue) {
      if(dateValue != null) {
        return moment(dateValue).format('DD/MMM/YYYY')
      }
    },
    convertUppercase(value) {
      return value.toUpperCase()
    },
    viewBranchDetails(branch) {
      localStorage.removeItem('userBranchSearch');
      
      if(branch.branchStatus.code == "A" && branch.associationStatus.code == "A") {
          localStorage.setItem("manageUserInd", 'true');
      } else {
          
          localStorage.setItem("manageUserInd", 'false');
      }
      let branchInfo = {
          corporateId: branch.corporateId,
          branchId: branch.branchId,
          corporateName: branch.corporateName,
          branch: branch.branch
      }
      localStorage.setItem('branchInfo', JSON.stringify(branchInfo));
      this.$router.push({
          name: "branchDetails",
          params: { corporateId: branch.branchId }
      });
    },
    async searchCPOBranches() {
      localStorage.removeItem('CPOBranchPage');
      this.pageNo = 1;
      localStorage.setItem("CPOBranchSearch", JSON.stringify({corporateName: this.corporateName, id: this.branchId,  branch: this.branch}))
      this.loaderTab = true;
      let result = await new CorporateService().cpoBranchAtPageByPaginatedWithSizeMatchingQuery(
        this.pageNo,
        this.pageRecords,
        localStorage.getItem('user.id'),
        {
          corporateName: this.corporateName,
          id: this.branchId,
          branch: this.branch
        }
      );
      if(result.data.length != 0) {
        this.totalRecords = result.meta.totalrecords;
        this.branches = result.data;
        (this.pagesList = new PaginationUtils().getPagesList(
        this.totalRecords,
        this.pageRecords,
        this.pageNo
        )),
        (this.totalPages = new PaginationUtils().getTotalPages(
        this.totalRecords,
        this.pageRecords
        ));
        this.norecordsfound = false;
        this.loaderTab = false;
      } else {
        this.branches = [];
        this.norecordsfound = true;
        this.loaderTab = false;
      }
    },
    clearFields() {
      this.corporateName = null;
      this.branchId = null;
      this.branch = null;
      document.getElementById("corporateName").value = null;
      document.getElementById("branchId").value = null;
      document.getElementById("branch").value = null;
      localStorage.removeItem('CPOBranchSearch');
      localStorage.removeItem('CPOBranchPage');
      this.branches = [];
      this.norecordsfound = true;
    },
    async loadPage(page) {
      localStorage.setItem('CPOBranchPage', page);
      this.loaderTab = true;
      this.pageNo = page;
      this.pagesList = new PaginationUtils().getPagesList(
        this.totalRecords,
        this.pageRecords,
        page
      );
      let result = await new CorporateService().cpoBranchAtPageByPaginatedWithSizeMatchingQuery(
        this.pageNo,
        this.pageRecords,
        localStorage.getItem('user.id'),
        {
            corporateName: this.corporateName,
            id: this.branchId,
            branch: this.branch
        }
      );
      if(result.data.length != 0) {
        this.totalRecords = result.meta.totalrecords;
        this.branches = result.data;
        (this.pagesList = new PaginationUtils().getPagesList(
        this.totalRecords,
        this.pageRecords,
        this.pageNo
        )),
        (this.totalPages = new PaginationUtils().getTotalPages(
        this.totalRecords,
        this.pageRecords
        ));
        this.norecordsfound = false;
        this.loaderTab = false;
      } else {
        this.branches = [];
        this.norecordsfound = true;
        this.loaderTab = false;
      }
    }
  }
})
</script>